import { Input } from "antd";
import React, { useEffect, useState } from "react";
const { TextArea } = Input;

interface Props {
  title: string;
  placeholder: string;
  onChange?: any;
  disabled?: boolean;
  data?: any;
  className?: string;
  rules?: any;
  setValue?: any;
  control?: any;
  name: string;
  maxLength?:number;
  allowNewLine?:boolean;
}

const TextAreaInput: React.FC<Props> = ({
  title,
  placeholder,
  onChange,
  disabled,
  data,
  className,
  maxLength = 100,
  allowNewLine = false
}) => {

  const [input, setInput] = useState<string>();
  useEffect(() => {
    setInput(data);
  }, [data]);

  return (
        <>
          <TextArea
            title={title}
            placeholder={placeholder}
            disabled={disabled}
            count={{
              show: true,
              max: maxLength,
            }}
            className={className}
            // showCount
            maxLength={maxLength}
            value={input}
            style={{ height: 120, marginBottom: 24 }}
            onKeyDown={(key) => {
              if(key.keyCode === 13 && !allowNewLine) {
                key.preventDefault();
              }
            }}
            onChange={(ev) => {
              setInput(ev.target.value.trimStart());
              onChange(ev.target.value.trimStart());
            }}
          />
          
        </>
      
  
  );

};

export default TextAreaInput;
